import { type BlockConfiguration, registerBlockType } from '@wordpress/blocks';

import metadata from './block.json';
import { Edit } from './edit';
import { Icon } from './icon';
import type { OrderInfoAttributes } from './types';

registerBlockType< OrderInfoAttributes >( metadata.name, {
	...( metadata as BlockConfiguration< OrderInfoAttributes > ),
	icon: Icon,
	edit: Edit,
} );
